import { clientFetch } from '../clientFetch';

export const getCodingByID = async (projectId) =>
  clientFetch(`/search/codings`, { params: { projectIds: [projectId], size: 1 } }).then((r) => r.results?.[0]);
